import { createSelector } from 'reselect'

export const selectUser = state => state.user

export const selectSuperAdminData = createSelector([selectUser], user => {
  const userInfo = user?.userRole
  if (!userInfo) return false
  return userInfo === 'Super Admin' || userInfo === 'Vice Chairman' || userInfo === 'Director'
})

// || userInfo === 'Director' || userInfo === 'Business Development Manager' ||

export const selectDirectorData = createSelector([selectUser], user => {
  const userInfo = user?.userRole
  if (!userInfo) return false
  return userInfo === 'Director'
})

export const selectBranchManagerData = createSelector([selectUser], user => {
  const userInfo = user?.userRole
  if (!userInfo) return false
  return userInfo === 'Business Development Manager'
})

export const selectSalesData = createSelector([selectUser], user => {
  const userInfo = user?.userRole
  if (!userInfo) return false
  return userInfo === 'Customer Relationship Manager'
})
